import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.module.scss';

const LoadingIndicator = ({ loadingText, className, ...props }) => (
  <div className={classNames(styles.loading_indicator, className)} {...props}>
    <Spinner animation='border' role='status' />
    <p className={styles.loading_text}>{loadingText}</p>
  </div>
);

LoadingIndicator.propTypes = {
  loadingText: PropTypes.string,
  className: PropTypes.string,
};

LoadingIndicator.defaultProps = {
  loadingText: 'Loading...',
  className: '',
};

export default LoadingIndicator;
